module.exports = __webpack_public_path__ + "img/ergo_small.bca1774a.jpg";